import store from "../store";
import actionTypes from "./actionTypes";

export function setLoading(loading, forceDarkTheme) {
    store.dispatch({
        type: actionTypes.SET_LOADING,
        payload: {loading, forceDarkTheme}
    });
}
